import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18next from 'i18next'
import Locize from 'i18next-locize-backend'
import VueI18Next from '@panter/vue-i18next'
import Message from 'vue-m-message'
import VTooltip from 'v-tooltip'
import VueClipboard from 'vue-clipboard2'
import VueSwal from 'vue-swal'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import VueMoment from 'vue-moment'
import 'vue-m-message/dist/index.css'
import './assets/tooltip.css'
import './assets/index.css'
import VueBlobJsonCsv from 'vue-blob-json-csv'

(async () => {
  try {
    Vue.config.productionTip = false

    Vue.use(VueBlobJsonCsv)
    Vue.use(VueI18Next)
    await i18next
      .use(Locize)
      .init({
        lng: 'en',
        fallbackLng: 'en',
        saveMissing: false,
        backend: {
          fallbackLng: 'en',
          referenceLng: 'en',
          projectId: process.env.VUE_APP_LOCIZE_PROJECT_ID,
          apiKey: process.env.VUE_APP_LOCIZE_API_KEY
        }
      })

    Vue.use(Message, { name: 'toast' })
    Vue.use(VTooltip)
    Vue.use(VueClipboard)
    Vue.use(VueSwal)
    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)

    new Vue({
      router,
      store,
      i18n: new VueI18Next(i18next),
      render: h => h(App)
    }).$mount('#app')
  } catch (e) {
    console.error(e)
  }
})()
